var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BrokerApproval"},[_c('FieldSet',{attrs:{"label":_vm.label,"values":_vm.values,"fields":_vm.fields,"validation":_vm.validation,"layout":_vm.layout,"disabled":_vm.disabled,"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }